export default {
  errorTitle: 'Resource Not Found',
  fetchError: 'Failed to load resource',
  resourceNotFound: 'The requested resource could not be found',
  available: 'Available',
  outOfStock: 'Out of Stock',
  borrowed: 'Borrowed',
  previousImage: 'Previous image',
  nextImage: 'Next image',
  noImage: 'No image available',
  description: 'Description',
  details: 'Details',
  sku: 'SKU',
  quantity: 'Quantity',
  category: 'Category',
  owner: 'Owner',
  personalResource: 'Personal Resource',
  location: 'Location',
  notes: 'Notes',
  currentStock: 'Current Stock',
  brand: 'Brand',
  weight: 'Weight',
  dimensions: 'Dimensions',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  tags: 'Tags',
  // New fields
  units_available: 'units available',
  needs_refill: 'Needs refill',
  borrowed_by: 'Borrowed by',
  unknown_user: 'Unknown user',
  ready_to_borrow: 'Ready to borrow',
  initial: 'initial',
  type: 'Type',
  consumable: 'Consumable',
  borrowable: 'Borrowable',
  // Actions
  borrow: 'Borrow',
  return: 'Return',
  consume: 'Consume',
  refill: 'Refill',
  reserve: 'Reserve',
  // Transaction History
  transactionHistory: 'Transaction History',
  noTransactions: 'No transactions found for this resource.',
  transactionsLoadError: 'Failed to load transaction history.',
  units: 'units',
  transactions: {
    borrowed: 'Borrowed',
    returned: 'Returned',
    consumed: 'Consumed',
    refilled: 'Refilled',
    reserved: 'Reserved',
    returnedOn: 'returned on',
    borrowings: 'Borrowings',
    consumptions: 'Consumptions',
    refills: 'Refills',
    overview: 'Overview',
    borrowingHistory: 'Borrowing History',
    actualBorrowing: 'Actual Borrowing',
    reservation: 'Reservation',
    borrowingsAndReservations: 'Borrowings & Reservations'
  }
};
